const $ = window.jQuery;

class ProgramMap {
  constructor() {
    if ($('.program-map').length > 0) {
      this.init();
    }
  }

  init() {
    this.programItems = document.querySelectorAll('.js-program-item');
    this.programList = document.querySelector('.js-program-list');
    this.programMap = document.querySelector('.js-program-map');
    this.mapPaths = document.querySelectorAll('.world-map path');
    this.allCountries = [];
    this.isActive = false;
    this.bindEvents();
    this.getAllCountries();
    this.populateMap();
  }

  bindEvents() {
    this.programMap.addEventListener('mouseover', this.mapMouseOver.bind(this));
    this.programMap.addEventListener('mouseout', this.mapMouseOut.bind(this));
    this.programList.addEventListener('mouseover', this.programMouseOver.bind(this));
    this.programList.addEventListener('mouseout', this.programMouseOut.bind(this));
  }

  mapMouseOver(event) {
    const el = event.target;
    const programs = el.dataset.programs;

    if (programs !== undefined) {
      const programsArr = programs.split(',');

      for (let i = 0; i < this.programItems.length; i++) {
        const currentProgram = this.programItems[i];
        const program = currentProgram.dataset.program;

        if (program !== undefined) {
          this.programList.classList.add('js-program-list-hover-active');
          if (programsArr.indexOf(program) >= 0) {
            currentProgram.classList.add('js-program-hover-active');
          }
        }
      }
    }
  }

  mapMouseOut() {
    this.programList.classList.remove('js-program-list-hover-active');
    for (let i = 0; i < this.programItems.length; i++) {
      const currentProgram = this.programItems[i];
      currentProgram.classList.remove('js-program-hover-active');
    }
  }

  programMouseOver(event) {
    const el = event.target;
    const program = el.dataset.program;

    if (program !== undefined) {
      let mapProgramsArr = '';
      for (let i = 0; i < this.mapPaths.length; i++) {
        const currentPath = this.mapPaths[i];
        const mapPrograms = currentPath.dataset.programs;

        if (mapPrograms !== undefined) {
          mapProgramsArr = mapPrograms.split(',');

          if (mapProgramsArr.indexOf(program) >= 0) {
            currentPath.classList.add('js-country-hover-active');
          }
        }
      }
    }
  }

  programMouseOut() {
    for (let i = 0; i < this.mapPaths.length; i++) {
      const currentPath = this.mapPaths[i];
      currentPath.classList.remove('js-country-hover-active');
    }
  }

  populateMap() {
    for (let i = 0; i < this.mapPaths.length; i++) {
      const currentPath = this.mapPaths[i];
      const slug = this.mapPaths[i].id;

      if (this.allCountries.some(v => slug === v)) {
        currentPath.classList.add('js-country-active');
      }

      for (let j = 0; j < this.programItems.length; j++) {
        const currentProgram = this.programItems[j];
        const countryData = currentProgram.dataset.locations;
        const countryProgram = currentProgram.dataset.program;
        const countryArr = countryData.split(',');

        if (countryArr.some(v => slug === v)) {
          if (!currentPath.hasAttribute('data-programs')) {
            currentPath.setAttribute('data-programs', countryProgram);
          } else {
            const currentAttr = currentPath.dataset.programs;
            const newAttr = `${currentAttr},${countryProgram}`;
            currentPath.setAttribute('data-programs', newAttr);
          }
        }
      }
    }
  }

  getAllCountries() {
    const allCountriesArr = [];

    for (let i = 0; i < this.programItems.length; i++) {
      const currentProgram = this.programItems[i];
      const countryData = currentProgram.dataset.locations;
      const countryArr = countryData.split(',');
      allCountriesArr.push(countryArr);
    }

    this.allCountries = this.arrayDeDuplicate(allCountriesArr.flat());
  }

  /*
   *  Remove duplicates in array
   */
  // https://stackoverflow.com/questions/1584370/how-to-merge-two-arrays-in-javascript-and-de-duplicate-items/54074371
  arrayDeDuplicate(...args) {
    const set = new Set();
    for (const arr of args) {
      arr.map(value => {
        set.add(value);
      });
    }
    return [...set];
  }
}

export default ProgramMap;
